import { CountryPicturesService } from './../../../@core/mock/country-pictures.service';
import { NbMenuService } from '@nebular/theme';
import { CountryData, AllCountry, Country, AfricanCountry, AmericanCountry, NorthAmericanCountry, CaraibeanCountry, EuropeanCountry, SouthAmericanCountry, CentraleAmericanCountry, AsianCountry, MoyenOrientCountry, OceanAtlantiqueCountry, OceanIndienCountry, OceanPacifiqueCountry } from './../../../@core/data/country';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { takeWhile } from 'rxjs/operators';
import { forkJoin } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-country-list',
  styleUrls: ['./country-list.component.scss'],
  templateUrl: './country-list.component.html',
})
export class CountryListComponent implements OnDestroy, OnInit {

  private alive = true;

  allCountries: any[];
  africanCountries: any[];
  americanCountries: any[];
  northAmericanCountries: any[];
  southAmericanCountries: any[];
  centraleAmericanCountries: any[];
  asianCountries: any[];
  caraibeanCountries: any[];
  europeanCountries: any[];
  moyenOrientCountries: any[];
  oceanAtlantiqueCountries: any[];
  oceanIndienCountries: any[];
  oceanPacifiqueCountries: any[];

  selectedRegion: any[];
  selectedItem: any;
  href: string = '' ;


  constructor(private countryService: CountryData,
    private countryPicturesService: CountryPicturesService,
    private menuService: NbMenuService,
    private route: Router,
    ) {
      this.menuService.getSelectedItem('menu')
      .pipe(takeWhile(() => this.alive))
      .subscribe( (menuBag) => {
        this.selectedItem = menuBag.item.title;
      });
    forkJoin(
      this.countryService.getAllCountry(),
    )
      .pipe(takeWhile(() => this.alive))
      .subscribe(([allCountries]: [AllCountry[]]) => {
        this.allCountries = allCountries;
      });
    forkJoin(
      this.countryService.getAfricanCountry(),
    )
      .pipe(takeWhile(() => this.alive))
      .subscribe(([africanCountries]: [AfricanCountry[]]) => {
        this.africanCountries = africanCountries;
      });
    forkJoin(
      this.countryService.getAmericanCountry(),
    )
      .pipe(takeWhile(() => this.alive))
      .subscribe(([americanCountries]: [AmericanCountry[]]) => {
        this.americanCountries = americanCountries;
      });
    forkJoin(
      this.countryService.getNorthAmericanCountry(),
    )
      .pipe(takeWhile(() => this.alive))
      .subscribe(([northAmericanCountries]: [NorthAmericanCountry[]]) => {
        this.northAmericanCountries = northAmericanCountries;
      });
    forkJoin(
      this.countryService.getSouthAmericanCountry(),
    )
      .pipe(takeWhile(() => this.alive))
      .subscribe(([southAmericanCountries]: [SouthAmericanCountry[]]) => {
        this.southAmericanCountries = southAmericanCountries;
      });
    forkJoin(
      this.countryService.getCentraleAmericanCountry(),
    )
      .pipe(takeWhile(() => this.alive))
      .subscribe(([centraleAmericanCountries]: [CentraleAmericanCountry[]]) => {
        this.centraleAmericanCountries = centraleAmericanCountries;
      });
    forkJoin(
      this.countryService.getAsianCountry(),
    )
      .pipe(takeWhile(() => this.alive))
      .subscribe(([asianCountries]: [AsianCountry[]]) => {
        this.asianCountries = asianCountries;
      });
      forkJoin(
        this.countryService.getEuropeanCountry(),
      )
        .pipe(takeWhile(() => this.alive))
        .subscribe(([europeanCountries]: [EuropeanCountry[]]) => {
          this.europeanCountries = europeanCountries;
        });
      forkJoin(
        this.countryService.getCaraibeanCountry(),
      )
        .pipe(takeWhile(() => this.alive))
        .subscribe(([caraibeanCountries]: [CaraibeanCountry[]]) => {
          this.caraibeanCountries = caraibeanCountries;
        });
      forkJoin(
        this.countryService.getMoyenOrientCountry(),
      )
        .pipe(takeWhile(() => this.alive))
        .subscribe(([moyenOrientCountries]: [MoyenOrientCountry[]]) => {
          this.moyenOrientCountries = moyenOrientCountries;
        });
    forkJoin(
      this.countryService.getOceanAtlantiqueCountry(),
    )
      .pipe(takeWhile(() => this.alive))
      .subscribe(([oceanAtlantiqueCountries]: [OceanAtlantiqueCountry[]]) => {
        this.oceanAtlantiqueCountries = oceanAtlantiqueCountries;
      });
    forkJoin(
      this.countryService.getOceanIndienCountry(),
    )
      .pipe(takeWhile(() => this.alive))
      .subscribe(([oceanIndienCountries]: [OceanIndienCountry[]]) => {
        this.oceanIndienCountries = oceanIndienCountries;
      });
    forkJoin(
      this.countryService.getOceanPacifiqueCountry(),
    )
      .pipe(takeWhile(() => this.alive))
      .subscribe(([oceanPacifiqueCountries]: [OceanPacifiqueCountry[]]) => {
        this.oceanPacifiqueCountries = oceanPacifiqueCountries;
      });
  }

  updatePictures(countryName: string) {
    this.countryPicturesService.onClickUpdate(countryName);
    this.countryPicturesService.onClickUpdatePictures(countryName);
  }
  goToCountry(countryType: string, countryName: string) {
    this.route.navigate(['/pages/country-content'],  { state: { countryType: countryType, countryName: countryName } });
  }
  ngOnInit() {
    this.menuService.getSelectedItem('menu')
      .pipe(takeWhile(() => this.alive))
      .subscribe( (menuBag) => {
        this.selectedItem = menuBag.item.title;
      });

      this.href = this.getNameByLink(this.route.url);
      console.log(this.route.url);
      console.log(this.href);

      if (this.selectedItem === 'Afrique' || this.href === 'Afrique') {
        this.selectedRegion = this.africanCountries;
      } else if (this.selectedItem === 'Asie' || this.href === 'Asie') {
        this.selectedRegion = this.asianCountries;
      } else if (this.selectedItem === 'Amérique' || this.href === 'Amérique') {
        this.selectedRegion = this.americanCountries;
      } else if (this.selectedItem === 'Amérique du Nord' || this.href === 'Amérique du Nord') {
        this.selectedRegion = this.northAmericanCountries;
      } else if (this.selectedItem === 'Amérique du Sud' || this.href === 'Amérique du Sud') {
        this.selectedRegion = this.southAmericanCountries;
      } else if (this.selectedItem === 'Amérique Centrale' || this.href === 'Amérique Centrale') {
        this.selectedRegion = this.centraleAmericanCountries;
      } else if (this.selectedItem === 'Caraibes' || this.href === 'Caraibes') {
        this.selectedRegion = this.caraibeanCountries;
      } else if (this.selectedItem === 'Europe' || this.href === 'Europe') {
        this.selectedRegion = this.europeanCountries;
      } else if (this.selectedItem === 'Moyen-Orient' || this.href === 'Moyen-Orient') {
        this.selectedRegion = this.moyenOrientCountries;
      } else if (this.selectedItem === 'Océan Atlantique' || this.href === 'Océan Atlantique') {
        this.selectedRegion = this.oceanAtlantiqueCountries;
      } else if (this.selectedItem === 'Océan Indien' || this.href === 'Océan Indien') {
        this.selectedRegion = this.oceanIndienCountries;
      } else if (this.selectedItem === 'Océan Pacifique' || this.href === 'Océan Pacifique') {
        this.selectedRegion = this.oceanPacifiqueCountries;
      }
  }

  getNameByLink(routerLink: string): string {
    if (routerLink === '/pages/afrique') return 'Afrique';
    if (routerLink === '/pages/amerique') return 'Amérique';
    if (routerLink === '/pages/amerique-du-nord') return 'Amérique du Nord';
    if (routerLink === '/pages/amerique-du-sud') return 'Amérique du Sud';
    if (routerLink === '/pages/amerique-centrale') return 'Amérique Centrale';
    if (routerLink === '/pages/asie') return 'Asie';
    if (routerLink === '/pages/caraibes') return 'Caraibes';
    if (routerLink === '/pages/europe') return 'Europe';
    if (routerLink === '/pages/moyen-orient') return 'Moyen-Orient';
    if (routerLink === '/pages/ocean-atlantique') return 'Océan Atlantique';
    if (routerLink === '/pages/ocean-indien') return 'Océan Indien';
    if (routerLink === '/pages/ocean-pacifique') return 'Océan Pacifique';

  }
  ngOnDestroy() {
    this.alive = false;
  }
}
